// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nVW2","question":"styles_question__1rVli","inputVisibleButton":"styles_inputVisibleButton__2waYD","note":"styles_note__2KJ-x"};